import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { CustomFormControl } from '../custom-form-control.component';
import { detectDecimalSeparator } from 'src/app/+grid-application-shared/utils/utils';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss', '../../styles/custom-control.styles.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true,
    },
  ],
})
export class InputNumberComponent extends CustomFormControl implements OnInit, ControlValueAccessor, Validator {
  @Input() label: string;
  @Input() minFract: number = 0;
  @Input() maxFract: number = 2;
  @Input() forceDisable: boolean;

  public detectDecimalSeparator = detectDecimalSeparator;

  constructor(inj: Injector) {
    super(inj);
  }

  ngOnInit(): void {
    this.initBase();
  }

  private _selectedValue: any = null;

  public get selectedValue(): any {
    return this._selectedValue;
  }
  public set selectedValue(value: any) {
    this._selectedValue = value;
    this.selectValue(value);
  }

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.applyDisabledState(isDisabled);
  }

  selectValue(value: number): void {
    this.onChange(this.selectedValue); // Notify Angular Forms
    this.onTouched(); // Mark as touched
  }

  registerOnValidatorChange?(fn: () => void): void {}
}
